<template>
  <div class="diff-tag-list-compare">
    <div v-if="useBlockLayout" class="diff-tag-block-row">
      <div class="diff-tag-block">
        <template v-if="Array.isArray(oldValue)">
          <template v-if="oldValue.length">
            <code
              v-for="item in oldValue"
              :key="`old-${item}`"
              class="ant-tag-red diff-tag-line"
            >
              <SearchHighlightText :text="getLabel(item)" :keyword="keyword" />
            </code>
          </template>
          <code v-else class="ant-tag-red diff-tag-line"> </code>
        </template>
        <code v-else class="ant-tag-red diff-tag-line">
          <SearchHighlightText :text="emptyText" :keyword="keyword" />
        </code>
      </div>
      <div class="diff-tag-block-arrow">
        =>
      </div>
      <div class="diff-tag-block">
        <template v-if="Array.isArray(newValue)">
          <template v-if="newValue.length">
            <code
              v-for="item in newValue"
              :key="`new-${item}`"
              class="ant-tag-green diff-tag-line"
            >
              <SearchHighlightText :text="getLabel(item)" :keyword="keyword" />
            </code>
          </template>
          <code v-else class="ant-tag-green diff-tag-line"> </code>
        </template>
        <code v-else class="ant-tag-green diff-tag-line">
          <SearchHighlightText :text="emptyText" :keyword="keyword" />
        </code>
      </div>
    </div>
    <template v-else>
      <template v-if="Array.isArray(oldValue)">
        <template v-if="oldValue.length">
          <code
            v-for="item in oldValue"
            :key="`old-${item}`"
            class="ant-tag-red"
          >
            <SearchHighlightText :text="getLabel(item)" :keyword="keyword" />
          </code>
        </template>
        <code v-else class="ant-tag-red"> </code>
      </template>
      <code v-else class="ant-tag-red">
        <SearchHighlightText :text="emptyText" :keyword="keyword" />
      </code>
      =>
      <template v-if="Array.isArray(newValue)">
        <template v-if="newValue.length">
          <code
            v-for="item in newValue"
            :key="`new-${item}`"
            class="ant-tag-green"
          >
            <SearchHighlightText :text="getLabel(item)" :keyword="keyword" />
          </code>
        </template>
        <code v-else class="ant-tag-green"> </code>
      </template>
      <code v-else class="ant-tag-green">
        <SearchHighlightText :text="emptyText" :keyword="keyword" />
      </code>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'
import SearchHighlightText from '@/components/ApiDoc/shared/SearchHighlightText.vue'

export default {
  name: 'DiffTagListCompare',
  components: {
    SearchHighlightText,
  },
  props: {
    fieldKey: String,
    oldValue: Array,
    newValue: Array,
    emptyText: {
      type: String,
      default: '',
    },
    getLabel: {
      type: Function,
      default: id => id,
    },
    blockThreshold: {
      type: Number,
      default: 4,
    },
    keyword: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const useBlockLayout = computed(() => [...(props.oldValue || []), ...(props.newValue || [])].length >= props.blockThreshold)

    return {
      useBlockLayout,
    }
  },
}
</script>

<style scoped>
.diff-tag-list-compare {
  display: contents;
}

.diff-tag-block-row {
  display: inline-flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  margin-left: 8px;
}

.diff-tag-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1;
}

.diff-tag-block .diff-tag-line {
  display: inline-block;
  margin-right: 0;
  white-space: pre;
  height: 20px;
}

.diff-tag-block-arrow {
  flex-shrink: 0;
  align-self: center;
  padding: 0 4px;
}
</style>
